import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, firstValueFrom, from, lastValueFrom, of } from 'rxjs';
import { map, mergeMap, take, tap } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';
import { UserService } from '../services/user.service';
import { MemberDataService } from '../content/home/services/member-data.service';
/*
import { JwtHelperService } from '@auth0/angular-jwt';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/glp-common/components/alert-dialog/alert-dialog.component';
import { LoggingService } from 'src/app/utilities/logging.service';
*/

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    public auth: AuthService,
    private userService: UserService,
    private memberDataService: MemberDataService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handle(req, next))
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {

      if(req.url.endsWith('/dbconnections/change_password')){
          return lastValueFrom(next.handle(req));
      }
      else{
        // let accessToken = await lastValueFrom(this.getAccessToken());
        let idToken = await lastValueFrom(this.getIdToken());

        let setParamsObject = {};
        setParamsObject["email"] = idToken.email;
        if(this.memberDataService.selectedGroupID && !req.params.get('groupId') && !req.params.get('groupid') && !req.params.get('groupID')){
          setParamsObject["groupId"] = this.memberDataService.selectedGroupID.toString();
        }
        setParamsObject["isBroker"] = idToken.is_Broker || false;
        setParamsObject["isGroupLeader"] = idToken.is_group_leader || false;

        req = req.clone({
          setParams: setParamsObject
        });

        req = req.clone({
          headers: req.headers
            .set('Cache-Control', 'no-cache, no-store, must-reva``lidate')
            .set('Cache-directive', 'no-cache')
            .set('Pragma-directive', 'no-cache')
            .set('Pragma', 'no-cache')
            .set('Expires', '0')
            .set('Authorization', 'Bearer ' + idToken.__raw)
        });

        return lastValueFrom(next.handle(req));
      }

  }


/*   getAccessToken(): Observable<any> {
    return new Observable(observer => {
      this.auth.getAccessTokenSilently().subscribe((token) => {
        observer.next(token);
        observer.complete();
        //this.auth.idTokenClaims$.subscribe((account) => {observer.next(account); observer.complete();});

      });
    });
  } */


  getIdToken(): Observable<any> {
    return new Observable(observer => {
      this.auth.idTokenClaims$.subscribe((account) => {observer.next(account); observer.complete();});
    });
  }

}

